var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('widget',{attrs:{"color":"primary","title":"SparkShs Overview"}},[_c('div',{staticClass:"md-layout md-gutter"},[_c('div',{staticClass:"md-layout-item"},[_c('credential')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }